import React from 'react'
import { ReactComponent as TimeOutIllustration } from 'apps/fleet-planner/components/illustrations/ShareLoadIllustrations.svg'

export const ShareLoadDetailsExpired = () => {
  return (
    <div className='container mt8'>
      <div className='col-xs-12 flex justify-center items-center'>
        <div className='col-xs-6'>
          <div className='col-xs-12 flex justify-center'>
            <TimeOutIllustration />
          </div>
          <div className='col-xs-12 mt6 body-large flex justify-center tc'>
            You no longer have access to this load.
          </div>
          <div className='col-xs-12 mt2 flex justify-center tc'>
            Please contact your dispatcher if you need a new link.
          </div>
        </div>
      </div>
    </div>
  )
}
